import * as React from 'react';
import { FacetLink } from './FacetLink.js';

const FacetWithTextNode = ({ item , isActive , onPick , productType , children  })=>/*#__PURE__*/ React.createElement(FacetLink, {
        item: item,
        isActive: isActive,
        onPick: onPick,
        productType: productType,
        // The accessibileName is not needed because the visible text should be sufficient
        accessibleName: undefined
    }, children ? children : item.facetTerm)
;

export { FacetWithTextNode };
//# sourceMappingURL=FacetWithTextNode.js.map
